<div id="ip-common">
  <header>
    @if (!isProduction) {
      <lib-environment-banner></lib-environment-banner>
    }
    <lib-alert-info></lib-alert-info>
    <lib-notification-info></lib-notification-info>
    <lib-skip-to-content mainId="main-content"></lib-skip-to-content>
    <lib-site-header
      [site]="EtjansterSites.Bedom"
      [authenticated]="false"
    ></lib-site-header>
  </header>
  <main class="ip-body" id="main-content">
    <div class="container mt-5">
      <router-outlet></router-outlet>
    </div>
  </main>
  <lib-site-footer></lib-site-footer>
</div>
